"use strict";

exports.__esModule = true;
exports.default = Dashboard;
var _preact = require("preact");
var _classnames = _interopRequireDefault(require("classnames"));
var _isDragDropSupported = _interopRequireDefault(require("@uppy/utils/lib/isDragDropSupported"));
var _FileList = _interopRequireDefault(require("./FileList.js"));
var _AddFiles = _interopRequireDefault(require("./AddFiles.js"));
var _AddFilesPanel = _interopRequireDefault(require("./AddFilesPanel.js"));
var _PickerPanelContent = _interopRequireDefault(require("./PickerPanelContent.js"));
var _EditorPanel = _interopRequireDefault(require("./EditorPanel.js"));
var _PickerPanelTopBar = _interopRequireDefault(require("./PickerPanelTopBar.js"));
var _index = _interopRequireDefault(require("./FileCard/index.js"));
var _Slide = _interopRequireDefault(require("./Slide.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */

// http://dev.edenspiekermann.com/2016/02/11/introducing-accessible-modal-dialog
// https://github.com/ghosh/micromodal

var WIDTH_XL = 900;
var WIDTH_LG = 700;
var WIDTH_MD = 576;
var HEIGHT_MD = 330;
// We might want to enable this in the future
// const HEIGHT_LG = 400
// const HEIGHT_XL = 460

function Dashboard(props) {
  var isNoFiles = props.totalFileCount === 0;
  var isSingleFile = props.totalFileCount === 1;
  var isSizeMD = props.containerWidth > WIDTH_MD;
  var isSizeHeightMD = props.containerHeight > HEIGHT_MD;
  var dashboardClassName = (0, _classnames.default)({
    'uppy-Dashboard': true,
    'uppy-Dashboard--isDisabled': props.disabled,
    'uppy-Dashboard--animateOpenClose': props.animateOpenClose,
    'uppy-Dashboard--isClosing': props.isClosing,
    'uppy-Dashboard--isDraggingOver': props.isDraggingOver,
    'uppy-Dashboard--modal': !props.inline,
    'uppy-size--md': props.containerWidth > WIDTH_MD,
    'uppy-size--lg': props.containerWidth > WIDTH_LG,
    'uppy-size--xl': props.containerWidth > WIDTH_XL,
    'uppy-size--height-md': props.containerHeight > HEIGHT_MD,
    // We might want to enable this in the future
    // 'uppy-size--height-lg': props.containerHeight > HEIGHT_LG,
    // 'uppy-size--height-xl': props.containerHeight > HEIGHT_XL,
    'uppy-Dashboard--isAddFilesPanelVisible': props.showAddFilesPanel,
    'uppy-Dashboard--isInnerWrapVisible': props.areInsidesReadyToBeVisible,
    // Only enable “centered single file” mode when Dashboard is tall enough
    'uppy-Dashboard--singleFile': props.singleFileFullScreen && isSingleFile && isSizeHeightMD
  });

  // Important: keep these in sync with the percent width values in `src/components/FileItem/index.scss`.
  var itemsPerRow = 1; // mobile
  if (props.containerWidth > WIDTH_XL) {
    itemsPerRow = 5;
  } else if (props.containerWidth > WIDTH_LG) {
    itemsPerRow = 4;
  } else if (props.containerWidth > WIDTH_MD) {
    itemsPerRow = 3;
  }
  var showFileList = props.showSelectedFiles && !isNoFiles;
  var numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null;
  var numberOfGhosts = props.files ? Object.keys(props.files).filter(function (fileID) {
    return props.files[fileID].isGhost;
  }).length : null;
  var renderRestoredText = function renderRestoredText() {
    if (numberOfGhosts > 0) {
      return props.i18n('recoveredXFiles', {
        smart_count: numberOfGhosts
      });
    }
    return props.i18n('recoveredAllFiles');
  };
  var dashboard = (0, _preact.h)("div", {
    className: dashboardClassName,
    "data-uppy-theme": props.theme,
    "data-uppy-num-acquirers": props.acquirers.length,
    "data-uppy-drag-drop-supported": !props.disableLocalFiles && (0, _isDragDropSupported.default)(),
    "aria-hidden": props.inline ? 'false' : props.isHidden,
    "aria-disabled": props.disabled,
    "aria-label": !props.inline ? props.i18n('dashboardWindowTitle') : props.i18n('dashboardTitle'),
    onPaste: props.handlePaste,
    onDragOver: props.handleDragOver,
    onDragLeave: props.handleDragLeave,
    onDrop: props.handleDrop
  }, (0, _preact.h)("div", {
    "aria-hidden": "true",
    className: "uppy-Dashboard-overlay",
    tabIndex: -1,
    onClick: props.handleClickOutside
  }), (0, _preact.h)("div", {
    className: "uppy-Dashboard-inner",
    "aria-modal": !props.inline && 'true',
    role: props.inline ? undefined : 'dialog',
    style: {
      width: props.inline && props.width ? props.width : '',
      height: props.inline && props.height ? props.height : ''
    }
  }, !props.inline ? (0, _preact.h)("button", {
    className: "uppy-u-reset uppy-Dashboard-close",
    type: "button",
    "aria-label": props.i18n('closeModal'),
    title: props.i18n('closeModal'),
    onClick: props.closeModal
  }, (0, _preact.h)("span", {
    "aria-hidden": "true"
  }, "\xD7")) : null, (0, _preact.h)("div", {
    className: "uppy-Dashboard-innerWrap"
  }, (0, _preact.h)("div", {
    className: "uppy-Dashboard-dropFilesHereHint"
  }, props.i18n('dropHint')), showFileList && (0, _preact.h)(_PickerPanelTopBar.default, props), numberOfFilesForRecovery && (0, _preact.h)("div", {
    className: "uppy-Dashboard-serviceMsg"
  }, (0, _preact.h)("svg", {
    className: "uppy-Dashboard-serviceMsg-icon",
    "aria-hidden": "true",
    focusable: "false",
    width: "21",
    height: "16",
    viewBox: "0 0 24 19"
  }, (0, _preact.h)("g", {
    transform: "translate(0 -1)",
    fill: "none",
    fillRule: "evenodd"
  }, (0, _preact.h)("path", {
    d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
    fill: "#FFD300"
  }), (0, _preact.h)("path", {
    fill: "#000",
    d: "M11 6h2l-.3 8h-1.4z"
  }), (0, _preact.h)("circle", {
    fill: "#000",
    cx: "12",
    cy: "17",
    r: "1"
  }))), (0, _preact.h)("strong", {
    className: "uppy-Dashboard-serviceMsg-title"
  }, props.i18n('sessionRestored')), (0, _preact.h)("div", {
    className: "uppy-Dashboard-serviceMsg-text"
  }, renderRestoredText())), showFileList ? (0, _preact.h)(_FileList.default, {
    id: props.id,
    error: props.error,
    i18n: props.i18n,
    uppy: props.uppy,
    files: props.files,
    acquirers: props.acquirers,
    resumableUploads: props.resumableUploads,
    hideRetryButton: props.hideRetryButton,
    hidePauseResumeButton: props.hidePauseResumeButton,
    hideCancelButton: props.hideCancelButton,
    showLinkToFileUploadResult: props.showLinkToFileUploadResult,
    showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
    isWide: props.isWide,
    metaFields: props.metaFields,
    toggleFileCard: props.toggleFileCard,
    handleRequestThumbnail: props.handleRequestThumbnail,
    handleCancelThumbnail: props.handleCancelThumbnail,
    recoveredState: props.recoveredState,
    individualCancellation: props.individualCancellation,
    openFileEditor: props.openFileEditor,
    canEditFile: props.canEditFile,
    toggleAddFilesPanel: props.toggleAddFilesPanel,
    isSingleFile: isSingleFile,
    itemsPerRow: itemsPerRow
  })
  // eslint-disable-next-line react/jsx-props-no-spreading
  : (0, _preact.h)(_AddFiles.default, _extends({}, props, {
    isSizeMD: isSizeMD
  })), (0, _preact.h)(_Slide.default, null, props.showAddFilesPanel ? (0, _preact.h)(_AddFilesPanel.default, _extends({
    key: "AddFiles"
  }, props, {
    isSizeMD: isSizeMD
  })) : null), (0, _preact.h)(_Slide.default, null, props.fileCardFor ? (0, _preact.h)(_index.default, _extends({
    key: "FileCard"
  }, props)) : null), (0, _preact.h)(_Slide.default, null, props.activePickerPanel ? (0, _preact.h)(_PickerPanelContent.default, _extends({
    key: "Picker"
  }, props)) : null), (0, _preact.h)(_Slide.default, null, props.showFileEditor ? (0, _preact.h)(_EditorPanel.default, _extends({
    key: "Editor"
  }, props)) : null), (0, _preact.h)("div", {
    className: "uppy-Dashboard-progressindicators"
  }, props.progressindicators.map(function (target) {
    return props.uppy.getPlugin(target.id).render(props.state);
  })))));
  return dashboard;
}